import React, { useEffect, useState } from "react";

import dayjs from "dayjs";
import Drag from "../hooks/Drag";
import Table from "../ui/Table";
import Label from "../ui/Label";
import Spin from "../ui/Spin";
import { drawPrice } from "../utils/Utils";
import OtherConditions from "./OtherConditions";
import { PinIcon } from "../utils/Icons";
import Checkbox from "../ui/Checkbox";
import { loadInventory } from "../controllers/GlobalConroller";

import Cookies from "js-cookie";
export default function InventoryPubstock(props) {

    const { controller = "", setController = () => { }, is_order = false, pubstock = [], width = 541, loading = false, pending_orders = [], state = "", setState = () => { }, other_conditions = [], conditionSelected = {}, setConditionSelected = () => { } } = props;
    const [data, setData] = useState([...pubstock]);
    const { selected = {}, callback = () => { }, route = "" } = props;

    const [pinned, setPinned] = useState(false);
    const fItems = data.filter(i => i.priority === "F");
    const maxFDisplayOrder = Math.max(...fItems.map(i => i.display_order), -Infinity);

    const filtered = data.filter(i => i.priority === "F" || i.display_order < maxFDisplayOrder);
    const displayed = (state === "min" && filtered.length > 0) ? filtered : data;

    // Handle pinned
    let pinnedData = null;
    if (pinned) {
        const supplierMatches = data.filter(item => item.supplier === pinned);
        pinnedData = (supplierMatches.length > 0) ? supplierMatches : [{ supplier: pinned, onhand: "No stock" }];
    }

    // Final output
    const filteredData = pinned ? pinnedData : displayed;




    const addOrder = (e) => {
        const event = new CustomEvent("addOrder", { detail: e });
        window.dispatchEvent(event);
    }

    useEffect(() => {
        if (Array.isArray(pubstock)) {
            setData([...pubstock]);
        }
    }, [props.pubstock])


    const togglePin = (_obj) => {
        if (pinned) {
            setPinned(false);
        } else {
            setPinned(_obj?.supplier);
        }
    }

    const colorSupp = (_text, _status) => {
        if (_status === "F") {
            return (<strong style={{ "fontWeight": "700" }} className="text">{_text}</strong>)
        } else
            if (_status === "Y") {
                return (<strong className="text-light">{_text}</strong>)
            } else {
                return (<span className="label">{_text}</span>)
            }
    }

    const colorReturn = (e) => {
        if (e === "N") {
            return (<span className="text-red">{e}</span>)
        }
        if (e === "C") {
            return (<span className="text-yellow">{e}</span>)
        }
        return e;
    }

    const today = dayjs().format("MMMDD");

    const colorAsOf = (_date) => {
        if (!_date) return;
        _date = dayjs(_date * 1000).format("MMMDD");
        if (today === _date) { _date = "Now" }
        return <span className="text-green">{_date}</span>;
    }

    const prices = data.filter(item => {
        if (item.priority !== "P" && item.exchange_rate === 1 && item.profit_margin >= 40) {
            return true;
        } else {
            return false;
        }
    }).map(item => item.sell_price);
    const minSalesPrice = prices.length ? Math.min(...prices) : 0;

    const getP2 = (_cost = 0) => {
        if (minSalesPrice <= 0) return "-";
        const margin = ((minSalesPrice - _cost) / minSalesPrice) * 100;
        return (margin >= 0 && margin < 100) ? Math.round(margin) : "**";
    };


    const drawMore = () => {
        const favs = data.filter(item => item.priority === "F");
        const maxFDisplayOrder = favs.length ? Math.max(...favs.map(i => i.display_order)) : -Infinity;
        const moreItems = data.filter(item => item.priority !== "F" && item.display_order >= maxFDisplayOrder);
        const allItems = data.filter(item => item.supplier !== pinned);

        if (pinned) {
            return (
                <small>
                    <a onClick={() => { setPinned(false); setState("full") }}>
                        + {allItems.length} more
                    </a>
                </small>
            )

        }

        if (filtered.length === 0) {
            return <>SupWH</>;
        }

        if (state === "min") {
            if (!moreItems.length) {
                return <>SupWH</>;
            }
            return (
                <small>
                    <a onClick={() => setState("full")}>
                        + {moreItems.length} more
                    </a>
                </small>
            );
        } else {
            return (
                <small>
                    <a onClick={() => setState("min")}>Favs only</a>
                </small>
            );
        }
    };

    const columns = [
        {
            key: "supplier", width: 60, shrink: true, align: "left", grow: true, title: <>{drawMore()}</>, render: (e, f) => {

                if (is_order) {
                    return (<span className="pubstock-supp" onClick={() => { addOrder(f); }} >{colorSupp(e, f?.priority)}</span>)
                }
                return <span className="pubstock-supp" onClick={() => { addOrder(f); }} >{colorSupp(e, f?.priority)}</span>;
            }
        },
        {
            key: "onhand", width: 44, grow: true, title: <>O/H</>, render: (e, f) => {

                if (e === "No stock") {
                  
                    return (<span style={{ "position": "absolute", bottom : "2px", left: "85px", "color": "var(--text-red)" }}><small>N/A</small></span>)
                }
                return (<span className={(f?.priority === "P") ? "label" : "text-green"}>{e}</span>)
            }
        },
        {
            key: "onorder", width: 44, grow: true, title: <>O/O</>, render: (e, f) => {
                return (<span className={(f?.priority === "P") ? "label" : "text-green"}>{e}</span>)
            }
        },
        {
            key: "sell_price", width: 55, grow: true, title: <>SellPr</>, render: (e, f) => {
                return (e == minSalesPrice) ? <div className="text-olive">{drawPrice(e, true)}</div> : <>{drawPrice(e, true)}</>
            }
        },
        { key: "profit_margin", width: 21, grow: true, title: <>PM</> },
        {
            key: "profit_margin_2", width: 21, grow: true, title: <>P2</>, render: (e, f) => {

                if (e === "No stock") {
                    return (<></>)
                }

                return (<div className="text-olive">{getP2(f.cost)}</div>)
            }
        },
        {
            key: "supplier_price", width: 55, grow: true, title: <>SupPr</>, render: (e, f) => {
                return <span className={(f?.priority === "P") ? "label" : ""}>{drawPrice(e, true)}</span>
            }
        },
        {
            key: "discount", width: 25, grow: true, title: <>Disc</>, render: (e, f) => {
                return <span className={(f?.priority === "P") ? "label" : ""}>{e}</span>
            }
        },
        {
            key: "returnable", width: 15, grow: true, title: <>R</>, render: (e, f) => {
                return colorReturn(e);
            }
        },
        {
            key: "as_of", width: 55, grow: true, title: <>AsOf</>, render: (e) => {
                return colorAsOf(e);
            }
        },

        {
            key: "pin", width: 16, grow: true, title: <>QP</>, render: (e, f) => {
                return (<div><Checkbox onChange={() => togglePin(f)} value={pinned} /></div>)

            }
        },
    ]

    if (is_order) {


        if (filteredData?.length === 0 && !loading) {
            return (<div style={{ "padding": "15px", "width": "100%", "height": "50%" }}><Label style={{ "textAlign": "center" }}>No Pubstock for this title</Label></div>)
        }



        return (
            <>


            
                <Table
                    controller={controller}
                    grow
                    inline
                    className="pubstock_table"
                    onRowClick={(e) => { callback(e); }}
                    height={"auto"}
                    offset={0}
                    columns={columns}
                    width={"auto"}
                    data={(loading) ? [] : filteredData}
                    row_key={"supplier"}
                />
            </>
        )
    }

    const height = (filteredData.length) ? filteredData.length * 25 + 25 : 50;

    return (
        <div style={{ "position": "relative", "width": "100%" }}>
            {/* <Drag> */}
            <div className="shadow" style={{ "position": "absolute", "bottom": "1px", "right": "0px", "fontSize": "14px", "zIndex": "1" }}>
                <Spin loading={loading}>
                    <div style={{ "backgroundColor": "var(--text-black)", "borderTop": "0px solid var(--border-secondary)" }}>

                        <OtherConditions controller={controller} callback={(_stock) => {
    
                            if (controller === "reports") {                               
                                Cookies.set("inventory_stock_id", _stock.stock.stock_id);
                                window.ac = "inventory";
                                const event = new CustomEvent("switchController", { detail: "inventory" });
                                window.dispatchEvent(event);
                            } else {
                                alert("what to do here..")
                            }



                        }} data={(conditionSelected) ? conditionSelected?.other_conditions : other_conditions} />

                        {((pubstock?.length === 0 && !loading) &&
                            <div style={{ "textAlign": "center", "position": "relative", "top": "27px", "height": "0px", "zIndex": "10" }}>
                                <Label style={{ "textAlign": "center" }}>No Pubstock for this title</Label>
                            </div>
                        )}
                        <Table
                            controller={controller}
                            grow
                            inline
                            className="pubstock_table"
                            height={height}
                            offset={0}
                            columns={columns}
                            width={width}
                            data={(loading) ? [] : filteredData}
                            row_key={"supplier"}
                        />
                    </div>
                </Spin>
            </div>
            {/* </Drag> */}
        </div>
    );
}